import { render, staticRenderFns } from "./vis-timeline.vue?vue&type=template&id=60ed0cb0&scoped=true"
import script from "./vis-timeline.vue?vue&type=script&lang=js"
export * from "./vis-timeline.vue?vue&type=script&lang=js"
import style0 from "./vis-timeline.vue?vue&type=style&index=0&id=60ed0cb0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed0cb0",
  null
  
)

export default component.exports